import { create } from 'zustand';

type DamParams = {
    glb: string;
    productName?: string;
    sceneConfigJSON: string | null;
};

type VTOStore = {
    isDamMode: boolean;
    damParams: DamParams | null;
    setDamMode: (isDamMode: boolean) => void;
    setDamParams: (params: DamParams) => void;
};

const useVTOStore = create<VTOStore>((set, get) => ({
    isDamMode: false,
    damParams: null,
    setDamMode: (isDamMode) => set({ isDamMode }),
    setDamParams: (damParams) => set({ damParams })
}));

export default useVTOStore;
